import { DataSecurityAppActiveStatus } from '@types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';
import { DynamicQueryParams, KeyPaginationQueryParams, PaginatedResource } from '@sonar-software/sonar-ts-types';

export type GetDataSecurityAppStatusRequest = KeyPaginationQueryParams & DynamicQueryParams;

export type GetDataSecurityAppStatusResponse = PaginatedResource<DataSecurityAppActiveStatus>;

export const getDataSecurityAppStatus = createGetEndpoint<
	GetDataSecurityAppStatusRequest | undefined,
	GetDataSecurityAppStatusResponse
>((request) => `/api/v3/data-security/organization/app-status?${getQueryString(request)}`);
